import React from 'react'
import Header from '../components/header'
import Sidebar from '../components/sidebar'
import Deals from '../components/deals';
import { Handshake} from "lucide-react";

function DealsPage() {
    return (
        <>
        <Header
            title="Orders"
            icon={<Handshake className="w-5 h-5" />}
        />
        <Sidebar />
        <Deals />
        
        </>
        
    )
}

export default DealsPage;
